import usePlotActions from '../plots/usePlotActions';
import { useStationActions } from '../stations';
const useMyFarmItemActions = ({ itemId, itemKind, currentOrgId, newTabHandler, onRenameActionPress, onGeolocationActionPress, onRemoveSuccess, onArchiveSuccess, onRemoveStationSuccess, onAddOptionActionPress, onCompleteDataActionPress, excludedActions }) => {
    const plotActionsGroups = usePlotActions({
        plotId: itemKind === 'plot' ? itemId : undefined,
        newTabHandler,
        onRenameActionPress,
        onGeolocationActionPress,
        onRemoveSuccess,
        onArchiveSuccess,
        excludedActions: excludedActions
    });
    const stationActionsGroups = useStationActions({
        stationId: itemKind === 'station' ? itemId : undefined,
        currentOrgId,
        newTabHandler,
        onRenameActionPress,
        onGeolocationActionPress,
        onRemoveStationSuccess,
        onAddOptionActionPress,
        onCompleteDataActionPress,
        excludedActions: excludedActions
    });
    return itemKind === 'plot' ? plotActionsGroups : stationActionsGroups;
};
export default useMyFarmItemActions;
